import wmlogo from './wmlogo.png'
import chatIcon from './chatIcon.png'
import crossIcon from './crossIcon.png'
import profilePic from './profilePic.jpg'
import autoClicker from './autoClicker.png'
import streamWestDB from "./StreamWestBackendDB.png"
import videoSchema from './VideoSchema.png'
import backendRoutes from "./backendRoutingLayout.png"
import Orders from './Orders.png'
import Users from './Users.png'
import Products from './Products.png'
import BackendEcom from './BackendRoutesEcom.png'
import cellsV1 from './cellsV1.png'
import cellsV2 from './cellsV2.png'

export const assets = {
    wmlogo,
    chatIcon,
    crossIcon,
    profilePic,
    autoClicker,
    streamWestDB,
    videoSchema,
    backendRoutes,
    Orders,
    Users,
    Products,
    BackendEcom,
    cellsV1,
    cellsV2

}
